import { exportPDF } from "@api/stores/costs/exportPDF/api";
import { stats } from "@api/stores/costs/stats/api";
import { createDeleteApi } from "@api/util/createDeleteApi";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type { ICostsDto, ICostsGetAllParams, ICostsResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICostsResponse>>,
  IPathBaseParam,
  IPaginationParams & ICostsGetAllParams
>("stores.costs");
const postApis = createPostApi<
  IApiResponse<ICostsResponse>,
  IPathBaseParam,
  ICostsDto
>("stores.costs");
const getApis = createGetApi<
  IApiResponse<ICostsResponse>,
  IPathByIdParam,
  object
>("stores.costs");
const patchApis = createPatchApi<
  IApiResponse<ICostsResponse>,
  IPathByIdParam,
  ICostsDto
>("stores.costs");
const deleteApis = createDeleteApi<
  IApiResponse<ICostsResponse>,
  IPathByIdParam
>("stores.costs");

export const costs = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
  stats,
  exportPDF,
};
